
export enum TermsType {

  /** Terms Negotiated by customer; e.g. start and end date */
  negotiated = 0,

  /** Terms assigned by vendor  */
  assignedByVendor = 90,

}